//@flow
import * as React from 'react'

import { Button, Error, Flex } from 'components/common'
import { useI18n } from '~/core/i18n'
import { truncate } from '../../../../core/utils/functions'

type DeleteModalTemplateProps = {
  name: string,
  error?: any,
  isLoading?: boolean,
  ErrorComponent?: (error: any) => React.Node,
  onDelete: () => void
}

const DeleteModalTemplate = ({ name, error, isLoading, ErrorComponent, onDelete }: DeleteModalTemplateProps) => {
  const [msg] = useI18n()
  return (
    <Flex
      column
      style={{
        padding: '0.5rem',
        minWidth: 500,
        maxWidth: '50vw',
        alignItems: 'center'
      }}
    >
      {error && (ErrorComponent ? <ErrorComponent error={error} /> : <Error reason={error} />)}
      <Flex alignCenter as="p" justifyCenter>
        <i
          className="icon icon-l"
          style={{
            marginRight: '1rem'
          }}
        >
          circle_exclamation
        </i>
        <span>{msg('common.modal.deleteText', { name: truncate(name, 50) })}</span>
      </Flex>
      <Flex
        justifyCenter
        style={{
          marginTop: '1.5rem'
        }}
      >
        <Button
          disabled={isLoading}
          iconPosition="left"
          id="template-delete-btn"
          type="submit"
          xIcon="delete"
          xStyle="danger"
          onClick={onDelete}
        >
          {isLoading ? msg('common.button.deleting') : msg('common.button.delete')}
        </Button>
      </Flex>
    </Flex>
  )
}

export default DeleteModalTemplate
